import { useState } from 'react';
import axios from 'axios';
import { Sparkles, Send, Wand2 } from 'lucide-react';
import { toast } from 'sonner';
import { API } from './shared';

export function MailDirective({ mail, light, onSent }) {
  const [instruction, setInstruction] = useState(mail.manual_draft?.instruction || '');
  const [draft, setDraft] = useState(mail.manual_draft ? { subject: mail.manual_draft.subject, reply: mail.manual_draft.reply } : null);
  const [busy, setBusy] = useState('');
  const input = `w-full rounded-lg border p-2.5 text-xs ${light ? 'bg-white border-gray-200 text-gray-900' : 'bg-black/20 border-white/10 text-white'}`;
  const compose = async () => {
    if (!instruction.trim()) return toast.error('Écrivez d’abord la consigne.');
    setBusy('draft');
    try {
      const { data } = await axios.post(`${API}/admin/mailbot/${mail.id}/draft`, { instruction }, { withCredentials: true });
      setDraft({ subject: data.subject, reply: data.reply });
      toast.success('Brouillon rédigé : relisez, modifiez si besoin, puis envoyez');
    } catch (e) { toast.error(e.response?.data?.detail || 'Rédaction impossible.'); }
    setBusy('');
  };
  const send = async () => {
    if (!draft?.reply?.trim()) return;
    if (!window.confirm(`Envoyer cet email à ${mail.from_email} ?`)) return;
    setBusy('send');
    try {
      await axios.post(`${API}/admin/mailbot/${mail.id}/send`, draft, { withCredentials: true });
      toast.success(`Email envoyé à ${mail.from_email}`);
      setDraft(null); setInstruction('');
      onSent();
    } catch (e) { toast.error(e.response?.data?.detail || 'Envoi impossible.'); }
    setBusy('');
  };
  return (
    <div data-testid={`mail-directive-${mail.id}`} className={`mt-3 pt-3 border-t ${light ? 'border-gray-100' : 'border-white/10'}`} onClick={e => e.stopPropagation()}>
      <p className="font-bold text-[10px] uppercase mb-1.5 text-[#E9641A] flex items-center gap-1"><Wand2 size={11} /> Consigne email à envoyer</p>
      <textarea rows={2} data-testid={`mail-directive-input-${mail.id}`} value={instruction} onChange={e => setInstruction(e.target.value)} className={input}
        placeholder="Ex. : envoie un mail pour lui dire que le problème Fire TV est corrigé, qu’il peut retester et nous répondre en cas de souci" />
      <div className="flex flex-wrap gap-2 mt-2">
        <button onClick={compose} disabled={busy !== ''} data-testid={`mail-directive-compose-${mail.id}`}
          className="flex items-center gap-1 text-[11px] font-bold px-3 py-1.5 rounded-lg bg-[#E9641A] hover:bg-[#FE975E] text-white disabled:opacity-40">
          <Sparkles size={12} /> {busy === 'draft' ? 'Rédaction…' : draft ? 'Rédiger à nouveau' : 'Rédiger avec l’IA'}
        </button>
      </div>
      {draft && (
        <div className="mt-3 space-y-2" data-testid={`mail-draft-${mail.id}`}>
          <p className={`text-[10px] font-bold uppercase ${light ? 'text-gray-500' : 'text-white/40'}`}>Brouillon — modifiable avant envoi</p>
          <input data-testid={`mail-draft-subject-${mail.id}`} value={draft.subject} onChange={e => setDraft({ ...draft, subject: e.target.value })} className={input} />
          <textarea rows={10} data-testid={`mail-draft-body-${mail.id}`} value={draft.reply} onChange={e => setDraft({ ...draft, reply: e.target.value })} className={input} />
          <button onClick={send} disabled={busy !== ''} data-testid={`mail-draft-send-${mail.id}`}
            className="flex items-center gap-1 text-[11px] font-bold px-3 py-1.5 rounded-lg bg-emerald-500/15 text-emerald-400 border border-emerald-500/30 hover:bg-emerald-500/25 disabled:opacity-40">
            <Send size={12} /> {busy === 'send' ? 'Envoi…' : `Valider et envoyer à ${mail.from_email}`}
          </button>
        </div>
      )}
      {(mail.manual_replies || []).map(r => (
        <div key={r.id} data-testid={`mail-sent-${r.id}`} className={`mt-3 pt-2 border-t text-[11px] ${light ? 'border-gray-100' : 'border-white/10'}`}>
          <p className="font-bold text-[10px] uppercase mb-1 text-emerald-400">Email envoyé manuellement · {new Date(r.sent_at).toLocaleString('fr-FR')}{r.by ? ` · ${r.by}` : ''}</p>
          <p className="font-semibold">{r.subject}</p>
          <p className="whitespace-pre-wrap mt-1">{r.reply}</p>
        </div>
      ))}
    </div>
  );
}
